<template>
  <div id="google-citation">
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <h6>Rating</h6>
        </div>
        <div class="col-6">
          <h6>School Name</h6>
        </div>
        <div class="col-2">
          <h6>Distance</h6>
        </div>
      </div>
      <div class="row" v-for="(school, index) in schools.slice(0,5)" v-bind:key="index">
        <div class="col-2">
          <p>{{school.rating}}</p>
        </div>
        <div class="col-6">
          <a href="#" class="stretched-link" v-on:click="openNewTab(school)">{{school.name}}</a>
        </div>
        <div class="col-2">
          <p>{{distance(loc.lat(), loc.lng(), school.geometry.location.lat(), school.geometry.location.lng())}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GooglePlacesApi from '../../../../lib/googlePlacesApi.js'

export default {
  async mounted () {
    this.schools = await GooglePlacesApi.googleSearchLatLong(document.getElementById('google-citation'), 'schools', this.loc)
  },
  data () {
    return {
      schools: []
    }
  },
  props: {
    loc: Object
  },
  methods: {
    async openNewTab (school) {
      var details = await GooglePlacesApi.googleDetails(document.getElementById('google-citation'), school.place_id)
      var win = window.open(details.website, '_blank')
      if (win) win.focus()
    },
    distance (lat1, lon1, lat2, lon2, unit) {
      if ((lat1 === lat2) && (lon1 === lon2)) {
        return 0
      } else {
        var radlat1 = Math.PI * lat1 / 180
        var radlat2 = Math.PI * lat2 / 180
        var theta = lon1 - lon2
        var radtheta = Math.PI * theta / 180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
        if (dist > 1) {
          dist = 1
        }
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        if (unit === 'K') { dist = dist * 1.609344 }
        if (unit === 'N') { dist = dist * 0.8684 }
        return dist.toFixed(1)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/dropdowns/Schools.vue